import { Loader2 } from "lucide-react";
import { cardMeta, isWorking, jobLine } from "./connectionsModel";

/** A dot and a word or two: the four status words of a card, or what its job is doing right now. */
export function StatusPill({ tone = "quiet", children, testId, className = "" }) {
  return (
    <span className={`cx-pill cx-pill--${tone} ${className}`} data-testid={testId}>
      <span className="cx-pill__dot" aria-hidden="true" />
      {children}
    </span>
  );
}

/** The pill a card wears: its job while one runs, else its status word. */
export function CardStatusPill({ card, busy = false }) {
  const working = busy || isWorking(card?.job);
  if (working) {
    const word = jobLine(card?.job)?.replace(/…$/, "") || "Working";
    return (
      <span className="cx-pill cx-pill--busy" data-testid={`agent-connection-${card.app}-status`}>
        <Loader2 size={11} className="cx-spin" aria-hidden="true" />
        {word}
      </span>
    );
  }
  const meta = cardMeta(card);
  return <StatusPill tone={meta.tone} testId={`agent-connection-${card.app}-status`}>{meta.label}</StatusPill>;
}

export default StatusPill;
